module.exports = __webpack_public_path__ + "resource/img/image041.4004a7d4.png";